import { OfferData } from "@type/product"

export const offersOffsets = (offers: OfferData[]) => {
  const currentDate = new Date()
  const day = currentDate.getDay() // 0-6 Sunday - Saturday
  const hour = currentDate.getHours() // 0 - 23

  const regularShipping = offers?.[0]
  const fastShipping = offers?.[1]

  const regularOffset = () => {
    let offset = 0
    const vendor = regularShipping?.seller
    switch (day) {
      case 1: // Monday
        switch (vendor) {
          case "pbu":
          case "cgg":
            if (hour >= 12) {
              offset = 6
            }
            break
          case "ciu":
          case "piu":
            if (hour >= 17) {
              offset = 6
            }
            break
        }
        break
      case 2: // Tuesday
        offset = 5
        break
      case 3: // Wednesday
        offset = 4
        break
      case 4: // Thursday
        offset = 3
        break
      case 5: // Friday
        offset = 2
        break
      case 6: // Saturday
      case 0: // Sunday
        offset = 1
        break
    }

    return offset
  }

  const fastOffset = () => {
    let offset = 0
    const vendor = fastShipping?.seller
    switch (day) {
      case 1: // Monday
      case 3: // Wednesday
      case 5: // Friday
        switch (vendor) {
          case "pbu":
          case "cgg":
            if (hour >= 12) {
              offset = 2
            }
            break
          case "ciu":
          case "piu":
            if (hour >= 17) {
              offset = 2
            }
            break
        }
        break
      case 2: // Tuesday
      case 4: // Thursday
      case 6: // Saturday
      case 0: // Sunday
        offset = 1
        break
    }
    return offset
  }

  const regular = () => {
    if (regularShipping) {
      switch (regularShipping?.seller) {
        case "bia":
          return 1
        case "gzb":
          return 0
        default:
          return regularOffset()
      }
    }
    return 0
  }

  const fast = () => {
    if (fastShipping) {
      switch (fastShipping?.seller) {
        case "bia":
          return 1
        case "gzb":
          return 0
        default:
          return fastOffset()
      }
    }
    return 0
  }

  const reOffers =
    regular() +
      (regularShipping?.deliveryLeadTime?.minValue +
        regularShipping?.deliveryLeadTime?.maxValue) /
        2 <=
    2 +
      fast() +
      (fastShipping?.deliveryLeadTime?.minValue +
        fastShipping?.deliveryLeadTime?.maxValue) /
        2
      ? offers?.slice(0, 1)
      : offers

  return {
    regularOffset: regular(),
    fastOffset: fast(),
    offers: reOffers,
    price: reOffers.length > 1 ? reOffers?.[1]?.price : reOffers?.[0]?.price,
  }
}
